import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMant from '../../../../../components/extras/SidePanelMant';
import TableManttos from '../../../../../components/tables/tableMantto';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemNote } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';




export const CMANotesAnswerPage = () => {
    const { parameters, menu } = useGlobalState();


    const [notes, setNotes] = useState<ItemNote[]>([]);
    const [note, setNote] = useState<ItemNote>();
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [detailPanel, setDetailPanel] = useState(false);
    const [month, setMonth] = useState("");
    const [filteringText, setFilteringText] = useState("");


    const handleGetNote = async (idMaintenance: Number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/mants/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idMaintenance: idMaintenance,
                    images: true,
                    read: true,
                    logs: true,
                    equipment: true
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.note) {
                setNote(data.note)
                setDetailPanel(true)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleAddNote = async (message: any) => {
        try {
            let body = {
                ...message,
                statusesMant: [0, 1],
                limit: 1,
                orderBy: "dateSubmited",
                order: "desc",
                orderBy2: "idMaintenance",
                order2: "desc",
            }

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/mants/addnote',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.code === 0) {
                setNote(undefined);
                setTimeout(() => {
                    handleGetNotes();
                }, 50)

            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetNotes = async () => {
        try {
            setLoading(true);
            setNotes([]);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/mants/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    //month: parameters.period.split("-")[1],
                    //year: parameters.period.split("-")[0],
                    images: true,
                    limit: 200,
                    statusesMant: [0, 1],
                    orderBy: "dateSubmited",
                    order: "desc",
                    orderBy2: "idMaintenance",
                    order2: "desc"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.notes) {
                setNotes(data.notes)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredRecords = notes.filter(note => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            note.keyw.toLowerCase().includes(word) ||
            note.registration.toLowerCase().includes(word)
        );
    });
    useEffect(() => {
        if (parameters?.period !== "") {
            handleGetNotes()
        }
    }, [parameters?.period]);
    return (
        <CustomAppLayout
            toolsHide={true}
            splitPanelOpen={note !== undefined}
            onSplitPanelToggle={({ detail }) => setNote(undefined)}
            splitPanelSize={500}
            splitPanel={
                <SidePanelMant edit={true} note={note ?? {}}
                    onMessage={(m: any) => {
                        setNotes([])
                        handleAddNote(m);
                    }}
                />
            }
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header actions={<Favorites />} variant="h2">Notas no finalizadas {notes && notes.length > 0 ? " (" + notes.length + ")" : ""}</Header>
                    <TableManttos notes={notes} onSelect={(item: ItemNote) => handleGetNote(item.idMaintenance)}
                        onRefresh={() => handleGetNotes()}
                    />
                </SpaceBetween>
            }
        />
    );
};
